import { prepareCurrentUserData } from '../utils/currentUserContext'
import { useMatchedRouteOrgSlug } from '../utils/orgSlug'
import { useApiQuery } from '../utils/reactQuery'
// Loads the current user. When the route is org-scoped the `org_slug` is
// forwarded so the backend returns capabilities for that account; otherwise
// (landing, select-account) the user is loaded globally.
export function useCurrentUserQuery() {
  const apiOrgSlug = useMatchedRouteOrgSlug()

  return useApiQuery(
    'get',
    '/users/me',
    apiOrgSlug !== null
      ? {
          params: {
            query: {
              org_slug: apiOrgSlug,
            },
          },
        }
      : undefined,
    {
      select: prepareCurrentUserData,
      staleTime: 0,
    },
  )
}
